<template>
  <el-dialog
    :title="$t('config.profile.title.importExcelDialog')"
    :visible.sync="importExcelVisible"
    width="70%"
    :close-on-click-modal="false"
    @close="onReset"
  >
    <tab v-model="tabIndex" :tab-list="tabList" />

    <div v-if="tabIndex === 1" class="tab-content">
      <div class="grid-scroll" style="height: 500px">
        <GridVx
          ref="infoGrid"
          class="agGrid"
          :columns="infoCols"
          :rows="rows[0]"
        />
      </div>
    </div>
    <div v-else-if="tabIndex === 2" class="tab-content">
      <div class="grid-scroll" style="height: 500px">
        <GridVx
          ref="contactGrid"
          class="agGrid"
          :columns="contactCols"
          :rows="rows[1]"
        />
      </div>
    </div>
    <div v-else-if="tabIndex === 3" class="tab-content">
      <div class="grid-scroll" style="height: 500px">
        <GridVx
          ref="debitAccountGrid"
          class="agGrid"
          :columns="debitAccountCols"
          :rows="rows[2]"
          :auto-size-cell="true"
        />
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <div class="button-containers">
        <button class="btn primary small" @click="fnGetAgentExcelTemplate">
          {{ $t('config.profile.common.excelTemplateDownload') }}
        </button>

        <input
          ref="excel-upload-input"
          class="excel-upload-input"
          type="file"
          accept=".xlsx, .xls"
          @change="handleClick"
        />
        <button class="btn primary small" @click="handleUpload">
          {{ $t('config.profile.common.excelUploadButton') }}
        </button>
        <button
          class="btn primary small"
          :disabled="!excelFile"
          @click="fnInsertListAgentExcel"
        >
          {{ $t('config.profile.common.update') }}
        </button>
        <button
          class="btn primary small outline"
          @click="importExcelVisible = false"
        >
          {{ $t('config.profile.common.cancel') }}
        </button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import XLSX from 'xlsx'
import {
  getListAgentExcelTemplateApi,
  insertListAgentExcelApi
} from '@/api/configuration/profile/agent'
import Tab from '@/components/Tab'

export default {
  components: { Tab },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      importExcelVisible: this.value,
      tabIndex: 1, // 1 - 3

      rows: [],

      excelFile: null,

      excelData: {
        header: null,
        results: null
      }
    }
  },

  computed: {
    // tab
    tabList() {
      return [
        { label: this.$t('config.profile.dialog.tab1'), value: 1 },
        { label: this.$t('config.profile.dialog.tab2'), value: 2 },
        { label: this.$t('config.profile.dialog.tab3'), value: 3 }
      ]
    },
    // grid
    infoCols() {
      return [
        {
          headerName: 'Mã hồ sơ',
          field: 'Mã hồ sơ'
        },
        {
          headerName: 'Tên công ty, đại lý du lịch',
          field: 'Tên công ty, đại lý du lịch'
        },
        {
          headerName: 'Tên công ty trên hóa đơn',
          field: 'Tên công ty trên hóa đơn'
        },
        {
          headerName: 'Loại hồ sơ',
          field: 'Loại hồ sơ\n(1:Công ty, 2:Đại lý du lịch)'
        },
        {
          headerName: 'Mã doanh nghiệp',
          field: 'Mã doanh nghiệp'
        },
        {
          headerName: 'Mã số thuế',
          field: 'Mã số thuế'
        },
        {
          headerName: 'Tên ngân hàng',
          field: 'Tên ngân hàng'
        },
        {
          headerName: 'Số tài khoản',
          field: 'Số tài khoản'
        },
        {
          headerName: 'Địa chỉ 1',
          field: 'Địa chỉ 1'
        },
        {
          headerName: 'Địa chỉ 2',
          field: 'Địa chỉ 2'
        },
        {
          headerName: 'Quốc gia',
          field: 'Quốc gia'
        },
        {
          headerName: 'Tiểu bang',
          field: 'Tiểu bang'
        },
        {
          headerName: 'Thành phố',
          field: 'Thành phố'
        },
        {
          headerName: 'Mã bưu điện',
          field: 'Mã bưu điện'
        },
        {
          headerName: 'Email',
          field: 'Email'
        },
        {
          headerName: 'Số điện thoại 1',
          field: 'Số điện thoại 1'
        },
        {
          headerName: 'Số điện thoại 2',
          field: 'Số điện thoại 2'
        },
        {
          headerName: 'Mã phân khúc thị trường',
          field: 'Mã phân khúc thị trường'
        },
        {
          headerName: 'Mã nguồn',
          field: 'Mã nguồn'
        },
        {
          headerName: 'Người đại diện',
          field: 'Người đại diện'
        },
        {
          headerName: 'Email người đại diện',
          field: 'Email người đại diện'
        },
        {
          headerName: 'SĐT 1 của người đại diện',
          field: 'SĐT 1 của người đại diện'
        },
        {
          headerName: 'SĐT 2 của người đại diện',
          field: 'SĐT 2 của người đại diện'
        },
        {
          headerName: 'Ngày sinh của đại diện',
          field: 'Ngày sinh của đại diện'
        },
        {
          headerName: this.$t('config.profile.field.repIdCard'),
          field: 'Số căn cước \ncủa người đại diện'
        },
        {
          headerName: this.$t('config.profile.field.repIdCardDate'),
          field: 'Ngày cấp thẻ căn cước\ncủa người đại diện'
        },
        {
          headerName: this.$t('config.profile.field.repIdCardPlace'),
          field: 'Nơi cấp thẻ căn cước\ncủa người đại diện'
        },
        {
          headerName: 'Không in giá',
          field: 'Không in giá'
        },
        { headerName: this.$t('config.profile.field.note'), field: 'Ghi chú' }
      ]
    },

    contactCols() {
      return [
        {
          headerName: 'Mã hồ sơ',
          field: 'Mã hồ sơ'
        },
        {
          headerName: 'Tên liên hệ',
          field: 'Tên liên hệ'
        },
        {
          headerName: 'Vị trí',
          field: 'Vị trí'
        },
        {
          headerName: 'Email',
          field: 'Email'
        },
        {
          headerName: 'Số điện thoại 1',
          field: 'Số điện thoại 1'
        },
        {
          headerName: 'Số điện thoại 2',
          field: 'Số điện thoại 2'
        },
        {
          headerName: 'Ghi chú',
          field: 'Ghi chú'
        }
      ]
    },

    debitAccountCols() {
      return [
        {
          headerName: 'Mã hồ sơ',
          field: 'Mã hồ sơ'
        },
        {
          headerName: 'Tài khoản công nợ',
          field: 'Tài khoản công nợ'
        }
      ]
    }
  },

  watch: {
    value(nv, ov) {
      this.importExcelVisible = nv
    },
    importExcelVisible(nv, ov) {
      if (!nv) {
        this.$emit('input', nv)
      }
    }
  },
  methods: {
    // util validate
    beforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1

      if (isLt1M) {
        return true
      }

      this.$message({
        message: 'Please do not upload files larger than 1m in size.',
        type: 'warning'
      })
      return false
    },

    // handle event
    // generateData({ header, results }) {
    //   this.excelData.header = header
    //   this.excelData.results = results
    // },
    handleUpload() {
      this.$refs['excel-upload-input'].click()
    },
    handleClick(e) {
      const files = e.target.files
      this.excelFile = files[0]
      const rawFile = files[0] // only use files[0]
      if (!rawFile) return
      this.upload(rawFile)
    },
    upload(rawFile) {
      this.$refs['excel-upload-input'].value = null // fix can't select the same excel

      if (!this.beforeUpload) {
        this.readerData(rawFile)
        return
      }
      const before = this.beforeUpload(rawFile)
      if (before) {
        this.readerData(rawFile)
      }
    },
    readerData(rawFile) {
      // reset
      this.rows = []
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = e => {
          const data = e.target.result
          const workbook = XLSX.read(data, { type: 'array' })
          for (const i of workbook.SheetNames.keys()) {
            const sheetName = workbook.SheetNames[i]
            const worksheet = workbook.Sheets[sheetName]
            // const header = this.getHeaderRow(worksheet)
            const results = XLSX.utils.sheet_to_json(worksheet)
            this.rows.push(results)
          }

          resolve()
        }
        reader.readAsArrayBuffer(rawFile)
      })
    },
    getHeaderRow(sheet) {
      const headers = []
      const range = XLSX.utils.decode_range(sheet['!ref'])
      let C
      const R = range.s.r
      /* start in the first row */
      for (C = range.s.c; C <= range.e.c; ++C) {
        /* walk every column in the range */
        const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })]
        /* find the cell in the first row */
        let hdr = 'UNKNOWN ' + C // <-- replace with your desired default
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell)
        headers.push(hdr)
      }
      return headers
    },

    onReset() {
      this.tabIndex = 1 // 1 - 3
      this.rows = []
      this.excelFile = null
      this.excelData = {
        header: null,
        results: null
      }
    },

    // handle api call
    fnGetAgentExcelTemplate() {
      getListAgentExcelTemplateApi(null)
        .then(res => {
          if (!res.is_error) {
            const href = URL.createObjectURL(res)
            // create "a" HTML element with href to file & click
            const link = document.createElement('a')
            link.href = href
            link.setAttribute(
              'download',
              'agent-profile-template.xlsx'
              // res.headers['content-disposition'].split('filename=')[1],
            ) // or any other extension
            document.body.appendChild(link)
            link.click()
            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link)
            URL.revokeObjectURL(href)
          } else {
            throw new Error(res)
          }
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
        .finally(() => {})
    },
    fnInsertListAgentExcel() {
      const formData = new FormData()
      if (this.excelFile) {
        formData.append('excelFile', this.excelFile)
      }

      insertListAgentExcelApi(formData)
        .then(data => {
          if (!data.is_error) {
            this.$message({
              type: 'success',
              message: this.$t(`successMsg.${data.message}`)
            })
            // close dialog
            this.importExcelVisible = false
            this.$emit('resetSearch')
          } else {
            throw new Error(data)
          }
        })
        .catch(error => {
          // {
          //   "is_error": true,
          //   "error_list": [
          //     {
          //       "line": 2,
          //       "sheet": 1,
          //       "error_list": [
          //         "invalidEmail",
          //         "invalidNationCode",
          //         "invalidSourceCode",
          //         "invalidMarketSegCode",
          //         "invalidSalesPersonUsername"
          //       ]
          //     },
          //     {
          //       "line": 2,
          //       "sheet": 2,
          //       "error_list": [
          //         "invalidEmail",
          //         "notExistProfileCode"
          //       ]
          //     },
          //     {
          //       "line": 2,
          //       "sheet": 3,
          //       "error_list": [
          //         "notExistProfileCode",
          //         "notExistDebitAcc"
          //       ]
          //     }
          //   ]
          // }

          if (Array.isArray(error.response?.data?.error_list)) {
            const errorList = error.response?.data?.error_list
            for (const sheetErrorList of errorList) {
              const sheet = sheetErrorList.sheet
              for (const msg of sheetErrorList.error_list) {
                const msgCode = this.$t(`errorMsg.${msg}`)
                setTimeout(() => {
                  this.$message({
                    type: 'error',
                    message: `Sheet ${sheet}: ${msgCode}`
                  })
                }, 0)
              }
            }
          }
        })
        .finally(() => {})
    }

    //
  }
}
</script>

<style scoped>
.excel-upload-input {
  display: none;
  z-index: -9999;
}
</style>
